import {NativeTouchableOpacity} from '@/components/basic/touchable-opacity';
import {LazyImageBackground} from '@/components/basic/image';
import React from 'react';
import Text from '@/components/basic/text';
import {StyleSheet, View, Image} from 'react-native';
import theme from '@/style';
import {KeralaTicket} from '../result.type';
import dayjs from 'dayjs';
import {goTo} from '@/utils';
const rightArrow = require('@components/assets/icons/chevron-right.png');
const ListItem = ({issueNo, lotteryType, drawDate}: KeralaTicket) => {
  const formattedDrawTime = dayjs(drawDate).format('DD-MM-YYYY hh:mm A');

  return (
    <NativeTouchableOpacity
      style={[theme.flex.row, styles.wrap]}
      onPress={() =>
        goTo('KeralaResultDetail', {
          issueNo,
          drawDate: formattedDrawTime,
        })
      }>
      <LazyImageBackground
        width={120}
        height={68}
        style={[theme.flex.row, styles.left]}
        imageUrl={require('@/components/assets/imgs/result/ticket-left.kerala.webp')}>
        <View style={styles.issueWrap}>
          <Text
            style={[styles.issueNo]}
            main
            fontFamily="fontInterBold"
            fontSize={16}>
            {issueNo}
          </Text>
        </View>
      </LazyImageBackground>
      <View
        style={[
          theme.flex.flex1,
          theme.flex.row,
          theme.flex.centerByCol,
          theme.background.white,
          styles.right,
          styles.rightContent,
          theme.flex.between,
        ]}>
        <View>
          <Text
            main
            fontFamily="fontInterBold"
            fontSize={14}
            style={styles.title}>
            {lotteryType}
          </Text>
          <Text accent fontSize={12} style={styles.drawTime}>
            {formattedDrawTime}
          </Text>
        </View>
        <View>
          <Image source={rightArrow} style={styles.arrow} />
        </View>
      </View>
    </NativeTouchableOpacity>
  );
};

const styles = StyleSheet.create({
  wrap: {
    height: 68,
  },
  left: {
    width: 120,
  },
  issueWrap: {
    width: 88,
    height: 68,
    justifyContent: 'center',
    alignItems: 'center',
  },
  issueNo: {
    letterSpacing: -0.2,
    textAlign: 'center',
    lineHeight: 20,
  },
  title: {
    letterSpacing: -0.2,
    lineHeight: 17,
  },
  right: {
    borderWidth: 3,
    borderColor: '#FFE454',
    borderLeftWidth: 0,
  },
  rightContent: {
    paddingHorizontal: 16,
    height: 68,
  },
  drawTime: {
    marginTop: 2,
    lineHeight: 14,
  },
  arrow: {
    width: 14,
    height: 14,
    opacity: 0.65,
  },
});

export default ListItem;
